import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import WelcomeMessage from './WelcomeMessage';
import DigDeeper from './DigDeeper';
import Debate from './Debate';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WelcomeMessage />} />
        <Route path="/dig-deeper" element={<DigDeeper />} />
        <Route path="/debate" element={<Debate />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
